// import Error from '../components/ErrorBoundary';
import React from 'react';
import Button from '@rezdy/components/Button';
import TextStyle from '@rezdy/components/TextStyle';
import Layout from '../components/Layout';
import Message from '../components/Message';
import { REZDY_APP } from '../constants/auth';
import redirect from '../actions/redirect';
import { ErrorMessage } from '../components/ErrorMessage';
import { WithTranslation, withTranslation } from 'react-i18next';

export class ErrorRoute extends React.PureComponent<WithTranslation> {
    onSecondaryClick = () => {
        redirect({
            redirect_uri: `${REZDY_APP}/logout`,
        });
    };

    renderSecondaryAction = () => {
        const { i18n } = this.props;
        return (
            <Button action="secondary" onClick={this.onSecondaryClick} reversed>
                {i18n.t('secondaryAction')}
            </Button>
        );
    };

    render() {
        const context = 'retry';
        const { i18n } = this.props;
        return (
            <Layout secondaryAction={this.renderSecondaryAction()}>
                <ErrorMessage isDirty={true} i18nKey={'UNKNOWN'}></ErrorMessage>
                <TextStyle align="center">Or</TextStyle>
                <Button action="secondary" onClick={this.onSecondaryClick}>
                    {i18n.t('secondaryAction', { context })}
                </Button>
            </Layout>
        );
    }
}

export default withTranslation()(ErrorRoute);
